/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Potentialmartinuselementaryschoolid5Inputs */



/**

* @param {_Field_Potentialmartinuselementaryschoolid5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_potentialmartinuselementaryschoolid5 = /** @type {((inputs?: _Field_Potentialmartinuselementaryschoolid5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Potentialmartinuselementaryschoolid5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Schule")
});
export { _field_potentialmartinuselementaryschoolid5 as "_field_potentialMartinusElementarySchoolID" }